/* global Autodesk  */

// import { updateMarkupModal } from "../../helpers/actions/Action";

// import store from "../../helpers/store/Store";

// import { connect } from "react-redux";

function AwaToolBarExtension(viewer, options) {
  Autodesk.Viewing.Extension.call(this, viewer, options);
  this.panel = null;
}

AwaToolBarExtension.prototype = Object.create(
  Autodesk.Viewing.Extension.prototype
);
AwaToolBarExtension.prototype.constructor = AwaToolBarExtension;

AwaToolBarExtension.prototype.load = function () {
  if (this.viewer.toolbar) {
    // Toolbar is already available, create the UI
    let UI = new settingsPanel(this.viewer);
    UI.createUI();
  } else {
    // Toolbar hasn't been created yet, wait until we get notification of its creation
    this.onToolbarCreatedBinded = this.onToolbarCreated.bind(this);
  }
  return true;
};

AwaToolBarExtension.prototype.onToolbarCreated = function () {
  this.onToolbarCreatedBinded = null;
  let UI = new settingsPanel(this.viewer);
  UI.createUI();
};

class settingsPanel {
  constructor(viewer, props) {
    this.viewer = viewer;
    // this.boolMarkupModalmodal = false;
  }

  createUI = function () {
    let viewer = this.viewer;

    // button to show the docking panel
    let AssetDataButton = new Autodesk.Viewing.UI.Button(
      "Open Asset Data Panel"
    );
    // let ModelButton = new Autodesk.Viewing.UI.Button("Open Model Panel");
    let IssuesButton = new Autodesk.Viewing.UI.Button("Open Issues Panel");

    let FullScreenButton = new Autodesk.Viewing.UI.Button("Open fullscreen");

    // markup buttons
    // let textButton = new Autodesk.Viewing.UI.Button("Text");
    // textButton.setIcon("icon-markups-text");

    // let rectangleButton = new Autodesk.Viewing.UI.Button("Rectangle");
    // rectangleButton.setIcon("icon-markups-rectangle");

    // GO TO ASSET DATA
    AssetDataButton.onClick = function (e) {
      viewer.impl.resize();
    };
    AssetDataButton.setToolTip("Asset data");

    // GO TO model in bim360
    // ModelButton.onClick = function () {
    // let iOS =
    //   (!!navigator.platform &&
    //     /iPad|iPhone|iPhone Simulator|iPad Simulator/.test(
    //       navigator.platform
    //     )) ||
    //   (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    // let project = viewer.config.selectedProject;

    // if (iOS) {
    //   let win = window.location.assign(project.hrefbim360);
    //   win.focus();
    // } else {
    //   let win = window.open(project.hrefbim360, "_blank");
    //   win.focus();
    // }

    //   this.boolMarkupModal = !this.boolMarkupModal;

    //   console.log("MarkupModal", this.boolMarkupModal);

    //   store.dispatch(updateMarkupModal(this.boolMarkupModal));

    //   if (this.boolMarkupModal) {
    //     this.markupToolbar = new Autodesk.Viewing.UI.ControlGroup(
    //       "markupPanel"
    //     );
    //     this.markupToolbar.addControl(textButton);
    //     this.markupToolbar.addControl(rectangleButton);
    //     viewer.toolbar.addControl(this.markupToolbar);
    //   } else {
    //     this.markupToolbar.removeControl(textButton);
    //     this.markupToolbar.removeControl(rectangleButton);
    //     viewer.toolbar.removeControl(this.markupToolbar);
    //   }
    // };

    // ModelButton.setToolTip("Markups");
    // ModelButton.setIcon("icon-open-markups");

    // GO TO model issues in bim360
    IssuesButton.onClick = function (e) {
      let iOS =
        (!!navigator.platform &&
          /iPad|iPhone|iPhone Simulator|iPad Simulator/.test(
            navigator.platform
          )) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
      let project = viewer.config.selectedProject;

      //alert('ok');

      if (iOS) {
        let win = window.location.assign(project.hrefbim360 + "/issues");
        win.focus();
      } else {
        let win = window.open(project.hrefbim360 + "/issues", "_blank");
        win.focus();
      }
    };

    IssuesButton.setToolTip("Open issues in BIM360");
    IssuesButton.setIcon("icon-model-issues");

    let full = false;
    // GO TO model FullScreenButton
    FullScreenButton.addEventListener("click", (e) => {
      full = !full;
      let elem = document.getElementById(
        "theProjectViewer-" + viewer.config.id
      );
      if (full) {
        elem.classList.add("viewer-fullscreen");
        FullScreenButton.setIcon("icon-compress");
      } else {
        elem.classList.remove("viewer-fullscreen");
        FullScreenButton.setIcon("icon-expand");
      }

      if (window.document.documentMode) {
        let resizeEvent = window.document.createEvent("UIEvents");
        resizeEvent.initUIEvent("resize", true, false, window, 0);
        window.dispatchEvent(resizeEvent);
      } else {
        window.dispatchEvent(new Event("resize"));
      }
    });
    FullScreenButton.setToolTip("Model Fullscreen");
    FullScreenButton.setIcon("icon-expand");

    //SubToolbar
    this.subToolbar = new Autodesk.Viewing.UI.ControlGroup("AWAPanel");

    this.subToolbar.addControl(IssuesButton);
    // this.subToolbar.addControl(ModelButton);
    this.subToolbar.addControl(FullScreenButton);

    viewer.toolbar.addControl(this.subToolbar);
  };
}

AwaToolBarExtension.prototype.unload = function () {
  this.viewer.toolbar.removeControl(this.subToolbar);
  return true;
};

// const mapStateToProps = (state) => ({
//   boolMarkupModal: state.markupModalReducer.markupModal,
// });

// export default connect(mapStateToProps)(AwaToolBarExtension);

Autodesk.Viewing.theExtensionManager.registerExtension(
  "AwaToolBarExtension",
  AwaToolBarExtension
);
